/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Scope } from './Scope';
import {
    ScopeFromJSON,
    ScopeFromJSONTyped,
    ScopeToJSON,
} from './Scope';

/**
 * 
 * @export
 * @interface ModuleWithScopes
 */
export interface ModuleWithScopes {
    /**
     * 
     * @type {string}
     * @memberof ModuleWithScopes
     */
    name: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof ModuleWithScopes
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModuleWithScopes
     */
    gambytAdminOnly?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleWithScopes
     */
    enabledFeatures: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleWithScopes
     */
    features: Array<string>;
    /**
     * 
     * @type {Array<Scope>}
     * @memberof ModuleWithScopes
     */
    scopes: Array<Scope>;
}

/**
 * Check if a given object implements the ModuleWithScopes interface.
 */
export function instanceOfModuleWithScopes(value: object): value is ModuleWithScopes {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('enabledFeatures' in value) || value['enabledFeatures'] === undefined) return false;
    if (!('features' in value) || value['features'] === undefined) return false;
    if (!('scopes' in value) || value['scopes'] === undefined) return false;
    return true;
}

export function ModuleWithScopesFromJSON(json: any): ModuleWithScopes {
    return ModuleWithScopesFromJSONTyped(json, false);
}

export function ModuleWithScopesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModuleWithScopes {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
        'gambytAdminOnly': json['gambytAdminOnly'] == null ? undefined : json['gambytAdminOnly'],
        'enabledFeatures': json['enabledFeatures'],
        'features': json['features'],
        'scopes': ((json['scopes'] as Array<any>).map(ScopeFromJSON)),
    };
}

export function ModuleWithScopesToJSON(value?: ModuleWithScopes | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'id': value['id'],
        'gambytAdminOnly': value['gambytAdminOnly'],
        'enabledFeatures': value['enabledFeatures'],
        'features': value['features'],
        'scopes': ((value['scopes'] as Array<any>).map(ScopeToJSON)),
    };
}

